var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"dropdown-content"}},[(_vm.active)?_c('div',{staticClass:"dropdown-content_items"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }